import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonBadgeOptions from '../components/CommonBadgeOptions';
/**
import CommonButtonBadge from '../components/CommonButtonBadge';
*/
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import CommonImagePreview from '../components/CommonImagePreview';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;

class DataTablePublicDataPublicizeVacancies extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageUrls: {} 
        };
    }

    componentDidMount = () =>  {
        this.loadImages();
    }
    
    componentDidUpdate = (prevProps) => {
        const prevRows = prevProps.DataTable?.rows || [];
        const currentRows = this.props.DataTable?.rows || [];
    
        const hasChanged = prevRows.length !== currentRows.length ||
            prevRows.some((prevRow, i) => {
                const currRow = currentRows[i];
                return prevRow.id !== currRow.id ||
                       prevRow.photo_file_id !== currRow.photo_file_id;
            });
    
        if (hasChanged) {
            this.loadImages();
        }
    }
    
    loadImages = async () => {
        const { DataTable } = this.props;
        const imageUrls = await Actions.loadImageBlobUrls({
            rows: DataTable.rows,
            fileField: "photo_file_id",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
        });
        this.setState({ imageUrls });
    };

    render() {

        let props = this.props;

        let { onSetEdit, onDropDownChange, onReorder, onCheckDelete, onCheckDeleteAll, onPaginationChange, onPreviewFile } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, UserCookie } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.status !== '1') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead>
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-100p"></th>
                                        <th className="th-width-auto"></th>
                                        <th className="th-width-175p"></th>
                                        <th className="th-width-175p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;
                                        if (row.status === '1') { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {!util.isEmpty(row.photo_file_id) && (
                                                            <CommonImagePreview
                                                                src={this.state.imageUrls?.[row.id] || null}
                                                                width={80}
                                                                height={80}
                                                                alt="รูปภาพ"
                                                            />
                                                        )}
                                                    </td>
                                                    <td className="text-truncate" title={row.name}>
                                                        <p>{row.name}</p>

                                                        {(row.position_name || row.people_count) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.position_name && <><i className="fa-classic fa-light fa-briefcase fa-fw me-2"></i>ตำแหน่ง {row.position_name}</>}
                                                                {row.people_count && <><i className="fa-classic fa-light fa-user fa-fw ms-2 me-1"></i>จำนวน {util.formatNumber(row.people_count)} คน</>}
                                                            </p>
                                                        )}     
                                                        
                                                        {(row.user_fullname) && (
                                                            <p className="title-xs mt-1 mb-0 d-flex flex-wrap align-items-center">
                                                                <span className="me-3">
                                                                    <i className="fa-classic fa-light fa-user fa-fw me-2"></i>
                                                                    ผู้ลงประกาศ {row.user_fullname}
                                                                </span>
                                                            </p>
                                                        )}  

                                                        {(row.publicize_date || row.expired_date) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                <i className="fa-classic fa-light fa-clock fa-fw me-2"></i>วันที่ประกาศ&nbsp;
                                                                {(() => {
                                                                    let { publicize_date, expired_date } = row;

                                                                    let start_date = util.convertDateToBE(publicize_date);
                                                                    let end_date = util.convertDateToBE(expired_date);

                                                                    const start = util.parseDate(start_date);
                                                                    const end = util.parseDate(end_date);

                                                                    return util.displayDateRange(start, end);
                                                                })()}                                                                
                                                            </p>
                                                        )}                                                

                                                        {!util.isEmpty(row.files_file_id) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                <i className="fa-classic fa-light fa-paperclip fa-fw me-2"></i> 
                                                                ไฟล์แนบ
                                                                <span className="title-xs ms-2 mb-0 text-primary"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => onPreviewFile({id: row.files_file_id})}
                                                                >
                                                                    {row.files_file_name}
                                                                </span>
                                                            </p>
                                                        )}                                                 

                                                        {(row.enterprise_name) && (
                                                            <Badge bg="primary" className="badge-md mt-2" pill>{row.enterprise_name}</Badge>
                                                        )}

                                                    </td>
                                                    <td>
                                                        {(() => {
                                                            return (
                                                            <CommonButton
                                                                Fixlabel="ดูตัวอย่าง"
                                                                task="open-content"
                                                                rounded={true}
                                                                disabled={false}
                                                                inlineClass="btn-font-sm text-secondary"
                                                                callback={() => Actions.handlePreviewPub('general', row.id)}
                                                            />
                                                            );
                                                        })()}
                                                    </td>
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'publicize'}}
                                                            callback={(e, element) => onDropDownChange(e, element, {key: 'id', value: row.id} )} 
                                                            disabled={!['0', '1'].includes(UserCookie.types)}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default DataTablePublicDataPublicizeVacancies;
